<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('JUDUL')" :class="{'form-group': true, 'has-error': errors.has('judul')}">
        <label class="col-md-3"><span class="required-label">*</span>Judul Penelitian</label>
        <div class="col-md-6">
          <input
            type="text"
            name="judul"
            placeholder="Judul Penelitian"
            class="form-control"
            maxlength="255"
            v-model="model.judul"
            v-validate="isExist('JUDUL') ? 'required' : ''"
          >
          <span v-show="errors.has('judul')" class="error-label">Isi Judul Penelitian</span>
        </div>
      </div>
      <div v-show="isExist('KEDUDUKAN')" :class="{'form-group': true, 'has-error': errors.has('status')}">
        <label class="col-md-3"><span class="required-label">*</span>Kedudukan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="status"
            placeholder="Kedudukan"
            class="form-control"
            maxlength="50"
            v-model="model.status"
            v-validate="isExist('KEDUDUKAN') ? 'required' : ''"
          >
          <span v-show="errors.has('status')" class="error-label">Isi Kedudukan</span>
        </div>
      </div>
      <div v-show="isExist('TAHUN')" :class="{'form-group': true, 'has-error': errors.has('tahun')}">
        <label class="col-md-3"><span class="required-label">*</span>Tahun</label>
        <div class="col-md-6">
          <input
            type="text"
            name="tahun"
            placeholder="Tahun"
            class="form-control"
            maxlength="8"
            v-model="model.tahun"
            v-validate="isExist('TAHUN') ? 'required' : ''"
          >
          <span v-show="errors.has('tahun')" class="error-label">Isi Tahun</span>
        </div>
      </div>
      <div v-show="isExist('SPONSOR')" :class="{'form-group': true, 'has-error': errors.has('sponsor')}">
        <label class="col-md-3"><span class="required-label">*</span>Sponsor</label>
        <div class="col-md-6">
          <input
            type="text"
            name="sponsor"
            placeholder="Sponsor"
            class="form-control"
            maxlength="100"
            v-model="model.sponsor"
            v-validate="isExist('SPONSOR') ? 'required' : ''"
          >
          <span v-show="errors.has('sponsor')" class="error-label">Isi Sponsor</span>
        </div>
      </div>
      <div v-show="isExist('REKOMENDASI')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>Rekomendasi</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointRekomendasi"
            :headers="header"
            name="rekomendasi"
            :data="dataUpload"
            :on-error="handleError"
            :on-success="handleSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.rekomendasi"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf dan tidak boleh lebih dari 1 MB</strong></div>
          </el-upload>
          <div v-if="rekomendasiUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="rekomendasiUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
    </form>
    <center>
      <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
    </center>
  </div>
</template>

<script>
import api from '@/api'
import { baseURL } from '@/api/data'

export default {
  data () {
    return {
      init: false,
      loading: false,
      sending: false,
      rekomendasiUrl: null,
      model: {
        judul: null,
        status: null,
        tahun: null,
        sponsor: null
      },
      savedModel: null,
      file: {
        rekomendasi: []
      }
    }
  },
  updated () {
    this.$nextTick(function () {
      var elements = document.getElementsByClassName('el-upload__input')
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0])
      }
    })
  },
  computed: {
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    dataUpload () {
      let data = {nomor_pendaftar: this.nomorPendaftar}
      return data
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    docEndPointRekomendasi () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_penelitian/rekomendasi'
      } else {
        return 'test'
      }
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(18).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(response => {
                resolve(true)
              })
              .catch(e => {
                e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                scroll(0, 0)
                resolve(false)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              let rekomendasiUploaded = this.file.rekomendasi.length > 0
              !rekomendasiUploaded && this.isExist('REKOMENDASI') ? reject({message: 'belum ada file rekomendasi'}) : false
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 18)
    },
    initData () {
      if (!this.init) {
        this.getDataPenelitian()
        this.getRekomendasi()
        this.init = true
      }
    },
    handleError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.rekomendasi = [{name: 'rekomendasi_penelitian_' + this.nomorPendaftar + '.pdf'}]
        this.rekomendasiUrl = 'Test'
      }
    },
    handleExceed () {
      alert('maksimal 1 file')
    },
    handleSuccess (res, file) {
      this.getRekomendasi()
      alert('upload sukses')
    },
    beforeDocsUpload (file) {
      const isMIME = file.type === 'application/pdf'
      const isLt2M = file.size < 1000000
      !isMIME ? alert('Dokumen berformat pdf') : false
      !isLt2M ? alert('Dokumen tidak boleh lebih dari 1 MB') : false
      return isMIME && isLt2M
    },
    getDataPenelitian () {
      this.loading = true
      api.get('/v1/data_penelitian/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.model = responseData.data
            this.loading = false
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    getRekomendasi () {
      api.get('/v2/data_penelitian/rekomendasi/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.rekomendasi = [{name: 'rekomendasi_penelitian_' + this.nomorPendaftar + '.pdf'}]
            this.rekomendasiUrl = responseData.url
          }
        })
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/data_penelitian', {
              nomor_pendaftar: this.nomorPendaftar,
              ...this.model
            })
              .then(response => {
                let success = response.data.success
                if (success) {
                  this.sending = false
                  this.savedModel = model
                  resolve(response.data)
                }
              })
              .catch(e => {
                this.sending = false
                reject(e.response)
              })
          } else {
            this.sending = false
            resolve(true)
          }
        } else {
          this.sending = false
          resolve(true)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataPenelitian.vue